module.exports = __webpack_public_path__ + "img/gitlab.523d5e81.svg";